var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWorld = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 21,
    height: 21,
    rx: 2.5875,
    stroke: "#1E1E1E",
    strokeWidth: 2.13469
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.5249L9.7625 9.76245L14.9375 14.9374M17.525 17.5249C16.2312 16.2312 14.9375 14.9374 14.9375 14.9374M14.9375 14.9374L18.8187 11.0562L22.7 14.9374",
    stroke: "#1E1E1E",
    strokeWidth: 2.13469,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5844,
    cy: 7.82197,
    r: 1.94062,
    fill: "#1E1E1E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWorld);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/World.aedfa93835afa71665721dd9f4c56266.svg";